import {
    type ResizeLegacyImagesResponseType
} from "./type";
import {
    request
} from "../request";

const resizeLegacyImages = async (): Promise<ResizeLegacyImagesResponseType> => {
    return await request<ResizeLegacyImagesResponseType>("/auth/resizeLegacyImages", {
        method: "GET"
    });
};
export default resizeLegacyImages;
